// @flow

import type { Fetch } from "fetch-utilities";

import { jsonResponse, sendJson } from "fetch-utilities";

export const SET_QTY       = "store/cart/SET_QTY";
export const REMOVE_EXCESS = "store/cart/REMOVE_EXCESS";
export const PUTTING       = "store/cart/PUTTING";
export const LOADING        = "store/cart/LOADING";
export const LOADED        = "store/cart/LOADED";

const initialState = {
  items : [],
  summary: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_QTY:
      const { product, qty } = action;

      return {
        ...state,
        items: !qty ? state.items.filter(x => x.product.id !== product.id) :
          state.items.some(x => x.product.id === product.id) ?
            state.items.map(x => x.product.id === product.id ? { ...x, qty } : x) :
            [...state.items, { product, qty }]
      };

    case LOADED:
      return {
        ...state,
        state: LOADED,
        items: action.error ? state.items : action.payload.items,
        summary: action.error ? state.summary : action.payload.summary,
      };

    case PUTTING:
      return {
        ...state,
        state: PUTTING,
      };

    case REMOVE_EXCESS:
      return {
        ...state,
        items: state.items
          // remove 0 qty items
          .filter(x => action.skus.includes(x.product.sku) ? x.qty >= action.excess : true)
          // modify remaining item qtys
          .map(   x => action.skus.includes(x.product.sku) ? { ...x, qty: Math.max(x.qty - action.excess, 0) } : x)
      };

    default:
      return state;
  }
}

export const setQty = (qty, product) => ({
  type: SET_QTY,
  product,
  qty
});

export const load = () => (dispatch: Function, _getState: Function, client: Fetch) => {
  dispatch({
    type: LOADING
  });

  dispatch({
    type    : LOADED,
    payload : client("/cart").then(jsonResponse)
  });
};

export const remove = (item: Object) => (dispatch: Function, _getState: Function, client: Fetch) => {
  dispatch({
    type:     REMOVING,
    removeId: item.id,
    payload:  item
  });

  dispatch({
    type     : LOADED,
    removeId : item.id,
    payload  : client(`/cart/${item.id}`, { method: "DELETE" }).then(jsonResponse)
  })
};


export const put = (items: Object) => (dispatch: Function, getState: Function, client: Fetch) => {
  const body = {
    items: items.map(item => ({
      product: {
        id: item.productId,
      },
      qty: item.qty,
      attributes: item.attributes,
    }))
  };

  dispatch({
    type: PUTTING,
  });

  dispatch({
    type    : LOADED,
    payload : client("/cart", sendJson({ method: "PUT", body }))
      .then(jsonResponse)
      .catch(error => {
        throw error.errorCode ? error : { errorCode: "NETWORK_ERROR", cause: error };
        return getState().cart.data;
      })
  });
};

export const qtyLimiter = (excess, skus) => ({
  type: REMOVE_EXCESS,
  excess,
  skus
});
